/**
 *               ! ВАЖНО !
 * Когда добавляешь новые шаги или ошибки,
 * не забудь обновить массив stepsWithoutInitialData в папке constants,
 * он нужен чтобы не запрашивать данные на ноде, когда основные шаги лендинга не отображаются
 **/
export enum EJoinOtaLegalShortStep {
  Authorization = 'authorization',

  LegalData = 'legalData',
  Insurance = 'insurance',
  Success = 'success',

  Error = 'error',
  ErrorAlreadyAcceptedPublicOffer = 'errorAlreadyAcceptedPublicOffer',
  ErrorUserDoesNotHaveAccess = 'errorUserDoesNotHaveAccess',

  Unexpected = 'unexpected',
}
